// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2VScD","title":"Info_title__eG8Ox","links":"Info_links__2YUmt","link":"Info_link__q7e9j","logo":"Info_logo__XwOMU"};